import React, { Fragment, useEffect, useState } from "react";
import { brandColumn } from "Constants/TableColumns";
import { Radio } from "@material-ui/core";
import { useDispatch, useSelector } from "react-redux";
import RemoteTable from "Components/RemoteTable/RemoteTable";
import { read } from "Helpers/LocalStorage";
import { getAllBrandYaragh } from "Stores/actions";
import BackDropLoading from "Components/BackDropLoading/BackDropLoading";

function BrandTable({ data, onSelect, selected, idCountry, idStruct }) {
  const [loading, setLoading] = useState(false);
  const { arshivBrandDataPagination } = useSelector((state) => ({
    arshivBrandDataPagination: state.yaragh.arshivBrandDataPagination,
  }));
  const [sizePerPage, setSizePerPage] = useState(null);
  const [currentPage, setCurrentPage] = useState(null);
  const [total, setTotal] = useState(null);
  const [tblData, setTblData] = useState(null);

  const dispatch = useDispatch();

  useEffect(() => {
    setTblData(data);
    setSizePerPage(arshivBrandDataPagination.Limit);
    setCurrentPage(arshivBrandDataPagination.Page);
    setTotal(arshivBrandDataPagination.Total);
  }, [data, arshivBrandDataPagination]);

  const selectRow = {
    mode: "radio",
    clickToSelect: true,
    onSelect: (row) => onSelect(row),
    selected: [selected?.Id],
    classes: "selection-row",
    selectionRenderer: ({ checked, disabled }) => {
      return (
        <Radio
          className="selectRadio"
          checked={checked}
          disabled={disabled}
          color="default"
        />
      );
    },
  };

  const onTableChange = async (type, { page, sizePerPage }) => {
    try {
      setLoading(true);
      const paramsBrand = {
        KeyUser: read("userKey"),
        KeyGroup: read("groupKey"),
        Limit: sizePerPage,
        Page: page,
        IdStruct: idStruct,
        IdCountry: idCountry,
      };
      await dispatch(getAllBrandYaragh(paramsBrand));
      setCurrentPage(page);
      setSizePerPage(sizePerPage);
      setLoading(false);
    } catch (err) {
      console.error('[catch error]', err)
    }
  };

  return (
    <Fragment>
      {
        tblData &&
        <>
          <BackDropLoading loading={loading} />
          <RemoteTable
            selectRow={selectRow}
            data={tblData}
            keyField="num"
            columns={brandColumn}
            loading={loading}
            page={currentPage}
            sizePerPage={sizePerPage}
            totalSize={total}
            onTableChange={onTableChange}
          />
        </>
      }

    </Fragment>
  );
}

export default BrandTable;
